export const getAllergenId = (a) => {
  const id =
    a?.id ??
    a?.allergen_ID ??
    a?.allergenId ??
    a?.allergenID ??
    a?.Allergen_ID ??
    null;
  if (id == null || id === "" || String(id) === "null" || String(id) === "undefined") {
    return null;
  }
  return id;
};

export const getAllergenName = (a) =>
  String(
    a?.allergen_Name ??
      a?.Allergen_Name ??
      a?.allergenName ??
      a?.name ??
      a?.Name ??
      ""
  ).trim();

export const getAllergenSolution = (a) =>
  String(a?.allergen_Solution ?? a?.Allergen_Solution ?? "").trim();

export const joinAllergenSolutions = (selected = []) =>
  (Array.isArray(selected) ? selected : [])
    .map((a) => getAllergenSolution(a))
    .filter(Boolean)
    .join(", ");

export const getAllergenKey = (a, index = 0) => {
  const id = getAllergenId(a);
  if (id != null) return `id:${String(id)}`;
  const name = getAllergenName(a).toLowerCase();
  if (name) return `name:${name}`;
  return `idx:${index}`;
};

/** Match by ID when both have one; otherwise fall back to name. */
export const allergensMatch = (a, b) => {
  if (!a || !b) return false;
  const idA = getAllergenId(a);
  const idB = getAllergenId(b);
  if (idA != null && idB != null) return String(idA) === String(idB);
  const nameA = getAllergenName(a).toLowerCase();
  const nameB = getAllergenName(b).toLowerCase();
  return !!nameA && nameA === nameB;
};

export const normalizeAllergen = (a) => ({
  ...a,
  id: getAllergenId(a),
});

export const parseAllergenString = (value) => {
  if (!value) return [];
  return String(value)
    .split(/[,;]+/)
    .map((s) => s.trim())
    .filter(Boolean);
};

export const resolveSelectedAllergens = (value, catalog = []) => {
  let items = [];
  if (Array.isArray(value)) {
    items = value.filter(Boolean);
  } else if (typeof value === "string") {
    items = parseAllergenString(value).map((name) => ({ allergen_Name: name }));
  }

  const seen = new Set();
  const result = [];
  for (const item of items) {
    const name = getAllergenName(item);
    if (!name && getAllergenId(item) == null) continue;
    const found = (catalog || []).find((a) => allergensMatch(a, item));
    const resolved = normalizeAllergen(
      found
        ? {
            ...found,
            allergen_Name: getAllergenName(found) || name,
          }
        : { ...item, allergen_Name: name }
    );
    const key = getAllergenKey(resolved);
    const nameKey = name ? `name:${name.toLowerCase()}` : key;
    if (seen.has(key) || seen.has(nameKey)) continue;
    seen.add(key);
    seen.add(nameKey);
    result.push(resolved);
  }
  return result;
};

export default {
  getAllergenId,
  getAllergenName,
  getAllergenSolution,
  joinAllergenSolutions,
  getAllergenKey,
  allergensMatch,
  normalizeAllergen,
  parseAllergenString,
  resolveSelectedAllergens,
};
